module.exports = __webpack_public_path__ + "static/media/share_add_person.2ec2a0a1.svg";